// extracted by mini-css-extract-plugin
module.exports = {"root":"src-components-page-upgrade-CompareCardBody-module__root--2iKTq"};